export default "<div class=\"tc-icon-wrap {{ iconClass }}\"></div>\n"